module.exports = __webpack_public_path__ + "static/media/locked.2687c50c.png";